<template lang="html">
  <!-- <Cascader v-if="false" transfer v-model="v" filterable :data="data" :disabled="!data.length" :render-format="l => l[2]" placeholder="Seleziona un conto"/> -->
  <!-- <div class=""> -->
    <!-- {{ ledgers}} -->
    <v-select v-model="v" :options="leds"/>
  <!-- </div> -->
</template>

<script>
export default {
  props: [
    'value',
    'ledgers',
  ],

  data () {
    return {
      data: [],
      leds: []
    }
  },

  mounted() {
    // if (this.ledgers) this.buildData()
    this.updateLeds()
  },

  methods: {
    buildData () {
      if (!this.ledgers) return
      var d = this.data = []
      this.ledgers.forEach(l => {
        // First level
        var s_type = d.find(s => l.type.startsWith(s.value))
        if (!s_type) {
          d.push(s_type = {
            value: l.type.substring(0, 2),
            label: {
              pa: 'Patrimoniale Attivo',
              pp: 'Patrimoniale Passivo',
              ce: 'Economico',
            }[l.type.substring(0, 2)],
            children: [],
          })
        }

        var s_cat = s_type.children.find(s => s.label == l.category)
        if (!s_cat) {
          s_type.children.push(s_cat = {
            value: l.category,
            label: l.category,
            children: [],
          })
        }

        // Second level
        s_cat.children.push({
          value: l.id,
          label: `[${l.code}] ${l.name}`,
        })
      })
    },

    updateLeds () {
      this.leds = this.ledgers ? this.ledgers.map(l => ({
        id: (l.id),
        label: `[${l.code}] ${l.name}`
      })) : []
    }
  },

  computed: {
    v: {
      get() {
        return this.value ? this.leds.find(e => e.id == this.value) : null
      },
      set(v) {
        this.$emit('input', v ? v.id : null)
      }
    }
  },

  watch: {
    ledgers () {
      console.log('chaned')
      this.updateLeds()
    }
  }


}
</script>

<style lang="css">
</style>
